<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="`Pindah perangkat`" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div class="f-16 f-regular f-c-black">
                    <label class="m-d-0 f-regular f-14 f-c-midgrey">
                        Seluruh pesan WA akan dikirim menggunakan <span class="f-bold">{{ device.nama }}</span
                        >. Yakin ingin memindah ke perangkat ini?
                    </label>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div class="">
                    <SOButton
                        :primary="true"
                        :full="true"
                        :text="'Ya, pindahkan'"
                        :id="`do-change-device`"
                        :disable="isFetching"
                        :loading="isFetching"
                        @action="saveUpdate"
                    />
                    <SOButton
                        :outline="true"
                        :full="true"
                        :text="'Batal'"
                        :id="'batal-update-nomor'"
                        :disable="isFetching"
                        :loading="isFetching"
                        @action="cancelUpdate"
                    />
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import resulter from "@/store/utils/resulter";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";

import { moduleName } from "../../store/state";

export default {
    name: "ConfirmSwitchDevice",
    components: {
        SOSlotModal,
        SOButton,
    },
    data() {
        return {
            backLink: "wa_autosender.detail_perangkat.daftar_oulet.set_draft",
            modalId: "confirm-ganti-device",
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
    },
    watch: {
        dataDeviceTiny: function(newDat, oldDat) {
            if (newDat.number !== oldDat.number) {
                this.setDevice({ type: "iddevice", data: newDat.iddevice });
                this.setDevice({ type: "nama", data: newDat.nama });
                this.setDevice({ type: "nomor", data: newDat.number });
            }
            this.back();
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            device: "device",
            dataDeviceTiny: "dataDeviceTiny",
            isFetching: "isFetching",
            response: "response",
        }),
    },
    methods: {
        ...mapActions({
            setFetching: `${moduleName}/setFetching`,
            setResponse: `${moduleName}/setResponse`,
            changeDevice: `${moduleName}/changeDevice`,
            getSettingWa: `${moduleName}/getSettingWa`,
            getDetailTinyDevice: `${moduleName}/getDetailTinyDevice`,
            setDevice: `${moduleName}/setDevice`,
            resetDevice: `${moduleName}/resetDevice`,
            resetListPerangkat: `${moduleName}/resetListPerangkat`,
        }),
        async back() {
            await this.$router.push({ name: this.backLink });
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        cancelUpdate() {
            let { defaultDevice } = this.$route.query;
            if (defaultDevice) {
                this.getDetailTinyDevice({ id_mesin: defaultDevice, setDevice: true });
            } else {
                this.back();
                this.resetDevice();
            }
        },
        saveUpdate() {
            let postUpdate = {
                idoutlet: this.$route.params.id_outlet,
                iddevice: this.device.iddevice,
            };

            this.changeDevice(postUpdate)
                .then((response) => {
                    let { code, status, msg, data } = response.data;

                    if (status && code === 200) {
                        this.getSettingWa({ idoutlet: postUpdate.idoutlet });
                        this.resetListPerangkat();
                        this.$router.push({ name: this.backLink, params: { id_device: this.device.iddevice } });
                    }

                    this.setFetching(false);
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                    this.setResponse(resulter.errorResult(e));
                });
        },
    },
};
</script>
<style scoped>
.diskon-percent {
    padding: 2px 8px;
    border-radius: 25px;
    background-color: #ededed;
    width: fit-content;
}

.paket-wa {
    max-width: unset;
}
@media (min-width: 320px) {
    .paket-wa {
        max-width: 170px;
    }
}

@media (min-width: 360px) {
    .paket-wa {
        max-width: 210px;
    }
}

@media (min-width: 400px) {
    .paket-wa {
        max-width: 250px;
    }
}
</style>
